"use strict";
/**
 * Обработчик для установки целей для систем аналитики
 * @param  {Object} proj)  Объект глобального пространства имен
 * @method  {function} init:   function(method [Инициализация всех целей]
 * @method  {function} set:    function(method [Установка цели]
 */
var Proj = (function(proj){

    proj.Targets = function(){
        var targets = [];

        function setup(){
            for (var i = 0; i < targets.length; i++) {
                if(targets[i].immediate){
                    set(i);
                }
            };
        }

        function set(idx){
            $(targets[idx].selector).on(targets[idx].method, targets[idx].fn);
        }

        return {
            init: function(data){
                if(data){
                    targets = data;
                    setup();
                }
            },
            set: function(method){
                for (var i = 0; i < targets.length; i++) {
                    if(targets[i].method == method){
                        set(i);
                    }
                };
            }
        }
    }();

    return proj;

})(Proj || {});




